import { AnlageWartungsHistoryEntryType } from "src/app/web-api/web-api";

export class WartungsHistoryExtendedFilterModel{
    public eventFilter: AnlageWartungsHistoryEntryType;
    public receiptTypeFilter: number[];
    public tasksShowDeleted: boolean;

    constructor(
        eventFilter?: AnlageWartungsHistoryEntryType, 
        receiptTypeFilter?: number[], 
        tasksShowDeleted?: boolean
    ){
        this.eventFilter = eventFilter || AnlageWartungsHistoryEntryType.None;
        this.receiptTypeFilter = receiptTypeFilter || [];
        this.tasksShowDeleted = tasksShowDeleted || false;
    }
}